import { render } from "./Community.vue?vue&type=template&id=ba8cfbc2&scoped=true"
import script from "./Community.vue?vue&type=script&lang=js"
export * from "./Community.vue?vue&type=script&lang=js"

import "./Community.vue?vue&type=style&index=0&id=ba8cfbc2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ba8cfbc2"

export default script